<template>
    <div class="advanced-filter-row">
        <div class="form-row advanced-standards-filter">
            <div class="search-results-summary mobile-only">
                <ResultsSummary/>
            </div>
            <div class="mobile-only">
                <span @click="toggleMobileFilters" class="advanced-filter-toggler">
                     {{ hiddenInMobile ? 'Show filters' : 'Hide filters' }}
                </span>
            </div>
            <div class="filterBy-header" :class="hiddenInMobile && 'hiddenInMobile'">
              {{$t('frm_filter_by')}} :
            </div>

            <div class="filters-tag-section mobile-only">
                <FilterTags/>
                <ClearFilters/>
            </div>
            <div class="facets-filters-container" :class="hiddenInMobile && 'hiddenInMobile'">
                <FacetMultiSelect :placeholder="$t('fld_publisher')"
                                  :searchable="true"
                                  :hasClear="true"
                                  name="filter[publisher][]" field="publisher"/>

                <FacetMultiSelect :placeholder="$t('frm_current_label')"
                                  name="filter[include][]" field="include"/>

                <FacetMultiSelect :placeholder="$t('fld_country')"
                                  :searchable="true"
                                  :hasClear="true"
                                  name="filter[country][]" field="country" />

                <FacetMultiSelect :placeholder="$t('filter_language')"
                                  :searchable="true"
                                  :hasClear="true"
                                  name="filter[language][]" field="language" />

                <FacetMultiSelect :placeholder="$t('filter_year')"
                                  :searchable="true"
                                  :hasClear="true"
                                  name="filter[year][]" field="year" />

                <AccordionFilterInput name="filter[query5]"
                                      :placeholder="$t('frm_search_within')"
                                      field="query5"/>
                <div class="filters-cba">

                    <div class="apply-filter">
                        <button class="sai-btn-purple" @click="applyFilter">{{ $t('frm_apply')}}</button>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import FilterTags from "@/components/SearchResultsPWA/Standards/FilterTags";
import ResultsSummary from "../../SearchResultsPWA/Standards/ResultsSummary";
import FacetMultiSelect from '../FacetMultiSelect';
import {createNamespacedHelpers} from 'vuex';
import ClearFilters from './ClearFilters';

const {mapActions} = createNamespacedHelpers('searchresults');

import AccordionFilterInput from '../../SearchResultFacets/AccordionFilterInput';

export default {
    name: 'SearchResultFacetsStandards',
    data() {
        return {
            hiddenInMobile: true
        }
    },
    components: {
        AccordionFilterInput,
        FacetMultiSelect,
        ResultsSummary,
        FilterTags,
        ClearFilters
    },
    methods: {
        ...mapActions([
            'setCurrentPage',
            'fetchItems',
            'setSearchResultsFilterSelectedValues',
            'setPWAStatus'
        ]),
        applyFilter() {
            this.setPWAStatus(false);
            window.scrollTo(0, 0);
            this.setCurrentPage(1);
            this.fetchItems('standards');
        },
        toggleMobileFilters() {
            this.hiddenInMobile = !this.hiddenInMobile;
        }
    }
}
</script>

